export const tag = `
    id
    name
    count
    slug
`;
